<template>
  <div
    style="
      min-height: 120px;
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <SyncLoader :color="$vuetify.theme.primary" :size="'10px'"></SyncLoader>
  </div>
</template>

<script>
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    SyncLoader
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  async mounted() {
    let lang = ''
    if (this.$route.query.state) {
      const parseState = JSON.parse(this.$route.query.state)
      lang = parseState.lang || 'th'
    }
    if (this.$route.query.error) {
      await this.$swal.fire({
        title: this.$route.query.error,
        text: this.$route.query.error_description,
        type: 'warning',
        confirmButtonText: 'Close'
      })
      this.$router.replace({
        path: `/${lang}/billing`,
        query: {
          tab: 'social-connect-management'
        }
      })
    } else if (this.$route.query.code) {
      const currentLocation = window.location.origin
      const redirectUrl = `${currentLocation}/callback/meta-catalog`
      const payload = {
        code: this.$route.query.code,
        redirect_uri: redirectUrl,
        page_id: this.selectedBot.pageid
      }
      const { isSuccess, message } = await this.$store.dispatch('connectMetaCatalog', payload)
      if (isSuccess) {
        this.$router.replace({
          path: `/${lang}/billing`,
          query: {
            tab: 'social-connect-management'
          },
          hash: '#meta-catalog-success'
        })
      } else {
        let _message = message
        await this.$swal
          .fire({
            title: 'Error',
            text: _message || '',
            type: 'error',
            confirmButtonText: 'Close'
          })
          .then(() => {
            this.$router.replace({
              path: `/${lang}/billing`,
              query: {
                tab: 'social-connect-management'
              }
            })
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/callback/MetaCatalog.vue